import http from '../http-common';

class ResourcesDataService {
  getAll() {
    return http.get("/resources");
  }

  get(id) {
    return http.get(`/resources/${id}`);
  }

  create(data) {
    return http.post("/resources/add", data);
  }

  update(data) {
    return http.put(`/resources/update`, data);
  }

  delete(id) {
    return http.put(`/resources/delete/${id}`);
  }
}

export default new ResourcesDataService();
